import { usePageTypeContext } from '../../contexts/ContentContext'
import { useElementContext } from '@ten24/slatwall-storefront-react-private/global'

const SearchListing = props => {
  const pageType = usePageTypeContext()
  const { BrandSearchListing, ProductTypeSearchListing, CategorySearchListing, SearchListingStack } = useElementContext()

    if (pageType === 'cptProductTypeListing') return <ProductTypeSearchListing {...props} />
    if (pageType === 'cptBrandListing') return <BrandSearchListing {...props} />
    if (pageType === 'cptCategoryListing') return <CategorySearchListing {...props} />
    return <SearchListingStack {...props} />
}

export { SearchListing }


